import React from 'react';
import Toast from './Toast';

const ToastContainer = ({ toasts, onRemove }) => {
    return (
        <div className="fixed top-4 right-4 z-50 space-y-2">
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    message={toast.message}
                    type={toast.type}
                    isVisible={toast.isVisible}
                    onClose={() => onRemove(toast.id)}
                    duration={toast.duration}
                />
            ))}
        </div>
    );
};

export default ToastContainer;
